import { Avatar, Box, Typography } from "@mui/material";
import { Message, UserInfo } from "../../../types";
import { colors } from "../../../theme/palette";
import { messagesFormatTimestamp } from "../../../utils/formatDate";
import { useQuery } from "@tanstack/react-query";
import { fetchEntityProfileInfo } from "../../../api/entity";
import { useDataFormatter } from "../../../hooks/useDataFormatter";
import { useFormattedTimestamp } from "../../../hooks/useFormattedTimestamp";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const isOwnMessage = (id: number, ownId: number) => id === ownId;

const MessageItem = ({ message, sendToUser }: { message: Message; sendToUser: UserInfo }) => {
  const { t } = useTranslation();
  const {
    createdAt,
    senderId,
    data: { text },
  } = message;

  const {
    data: userInfo = {},
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["userInfo"],
    queryFn: () => fetchEntityProfileInfo(),
  });

  const { id: userId } = userInfo;

  const { fullName, media, firstTwoChr } = useDataFormatter(sendToUser);

  const IS_OWN = isOwnMessage(senderId, userId);
  return (
    <Box
      sx={{
        display: "flex",
        columnGap: "12px",
        alignSelf: IS_OWN ? "flex-end" : "flex-start",
      }}
    >
      {IS_OWN ? (
        <></>
      ) : (
        <Avatar sx={{ width: "40px", height: "40px" }} src={media}>
          {firstTwoChr ? firstTwoChr : ""}
        </Avatar>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          rowGap: "6px",
          maxWidth: "385px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body14SemiBold"
            sx={{
              maxWidth: "70%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={IS_OWN ? t("pages.chat.you") : fullName ? fullName : ""}
          >
            {IS_OWN ? t("pages.chat.you") : fullName ? fullName : ""}
          </Typography>
          <Typography variant="body10Regular" sx={{ textTransform: "capitalize" }}>
            {useFormattedTimestamp(createdAt)}
          </Typography>
        </Box>
        <Typography
          variant="body13Regular"
          sx={{
            padding: "10px 40px 10px 14px",
            borderRadius: IS_OWN ? "8px 0px 8px 8px" : "0px 8px 8px 8px",
            background: IS_OWN ? colors.Green25 : colors.Gray50,
            minWidth: "220px",
            wordBreak: "break-word",
            whiteSpace: "pre-line",
          }}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

export default MessageItem;
